module.exports = __webpack_public_path__ + "img/noship.eba95860.png";